module.exports = __webpack_public_path__ + "img/logo.f02ca5cd.png";